/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_V1_Profile_Long_TermInputs */

const en_onboarding_v1_profile_long_term = /** @type {(inputs: Onboarding_V1_Profile_Long_TermInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I am a long term investor.`)
};

const de_onboarding_v1_profile_long_term = /** @type {(inputs: Onboarding_V1_Profile_Long_TermInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ich investiere langfristig.`)
};

const pt_br2_onboarding_v1_profile_long_term = /** @type {(inputs: Onboarding_V1_Profile_Long_TermInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invisto pensando no longo prazo.`)
};

const tr_onboarding_v1_profile_long_term = /** @type {(inputs: Onboarding_V1_Profile_Long_TermInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uzun vadeli yatırımcıyım.`)
};

const zh_cn2_onboarding_v1_profile_long_term = /** @type {(inputs: Onboarding_V1_Profile_Long_TermInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我是长期投资者。`)
};

const zh_hk2_onboarding_v1_profile_long_term = /** @type {(inputs: Onboarding_V1_Profile_Long_TermInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我是長線投資者。`)
};

const ko_kr2_onboarding_v1_profile_long_term = /** @type {(inputs: Onboarding_V1_Profile_Long_TermInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`저는 장기 투자자입니다.`)
};

const ru_ru2_onboarding_v1_profile_long_term = /** @type {(inputs: Onboarding_V1_Profile_Long_TermInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Я долгосрочный инвестор.`)
};

const es_419_onboarding_v1_profile_long_term = /** @type {(inputs: Onboarding_V1_Profile_Long_TermInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invierto a largo plazo.`)
};

/**
* | output |
* | --- |
* | "I am a long term investor." |
*
* @param {Onboarding_V1_Profile_Long_TermInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const onboarding_v1_profile_long_term = /** @type {((inputs?: Onboarding_V1_Profile_Long_TermInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_V1_Profile_Long_TermInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onboarding_v1_profile_long_term(inputs)
	if (locale === "de") return de_onboarding_v1_profile_long_term(inputs)
	if (locale === "pt-BR") return pt_br2_onboarding_v1_profile_long_term(inputs)
	if (locale === "tr") return tr_onboarding_v1_profile_long_term(inputs)
	if (locale === "zh-CN") return zh_cn2_onboarding_v1_profile_long_term(inputs)
	if (locale === "zh-HK") return zh_hk2_onboarding_v1_profile_long_term(inputs)
	if (locale === "ko-KR") return ko_kr2_onboarding_v1_profile_long_term(inputs)
	if (locale === "ru-RU") return ru_ru2_onboarding_v1_profile_long_term(inputs)
	return es_419_onboarding_v1_profile_long_term(inputs)
});